<template>
	<v-app
		style="
			display: flex;
			background-color: rgba(46, 136, 177, 0.671);
			justify-content: center;
			align-items: center;
		"
	>
		<v-main class="primary">
			<v-container fill-height>
				<v-row class="row align-items-center" style="overflow: visible">
					<v-card class="d-flex flex-row">
						<v-card-text>
							<v-img class="mx-auto my-6"
								   max-width="180"
								   alt="Pos Demo Server"
								   src="logo.jpg"></v-img>

							<h1 class="setFont flex my-4 w3-cursive primary--text">
								POS Demo server
							</h1>

							<v-form ref="loginForm"
									@submit.prevent="handleLoginSubmit">
								<v-text-field v-model="loginForm.email"
											  density="compact"
											  variant="outlined"
											  label="E-mail"
											  placeholder="E-mail"
											  prepend-icon="mdi-email-outline"
											  autocomplete="email"
											  :rules="[required('Email'), email('Email')]"></v-text-field>

								<v-text-field v-model="loginForm.password"
											  density="compact"
											  variant="outlined"
											  label="Password"
											  placeholder="Password"
											  prepend-icon="mdi-lock-outline"
											  :type="showPassword ? 'text' : 'password'"
											  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
											  @click:append="showPassword = !showPassword"
											  autocomplete="current-password"
											  :rules="[required('Password')]"></v-text-field>

								<v-btn type="submit"
									   density="compact"
									   size="large"
									   color="blue"
									   variant="outlined"
									   :loading="loading">

									Login
								</v-btn>
							</v-form>
						</v-card-text>
					</v-card>

				</v-row>
			</v-container>
		</v-main>
	</v-app>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { LOGIN, LOGOUT } from "@/store/_actiontypes";
import validations from "@/helpers/validations";
import router from "@/router/index";

export default {
	data() {
		return {
			loginForm: {
				email: "",
				password: "",
			},
			showPassword: false,
			showResult: false,
			...validations,
		};
	},
	computed: {
		...mapState({
			loading: (state) => state.loader.loading,
		}),
	},
	created() {
		//reset theme
		this.$vuetify.theme.dark = 0;
		// reset login status
		this.LOGOUT();
	},
	methods: {
		...mapActions("account", [LOGIN, LOGOUT]),
		handleLoginSubmit() {
			if (!this.$refs.loginForm.validate()) return;

			const { email, password } = this.loginForm;
			if (email && password) {
				this.LOGIN({ email, password });
			}
		},
	},
};
</script>

<style>
@import url("https://fonts.googleapis.com/css?family=Varela+Round");

.setFont {
	font-family: "Varela Round", Arial, Helvetica, sans-serif;
}

div img {
	box-shadow: 2.5px 2.5px 5px #ccc;
	border-radius: 25px;
}

.v-layout {
	overflow: visible;
}

.primary {
	display: flex;
	justify-content: center;
	text-align: center;
	flex-direction: column;
	align-items: center;
	margin: 0 auto;
	height: 100vh;
}

.row {
	justify-content: center;
}

.v-text-field {
	width: 30vw;
	margin: 0 auto;
}

h1 {
	font-family: Rockwell;
}

.v-text-field {
	border-radius: 25px;
}

.v-btn:hover {
	color: rgb(72, 197, 238);
	cursor: pointer;
	content: "Login" !important;
}

.v-btn:hover::after {
	content: "Login";
}

.v-btn::after {
	content: "Login";
}
</style>
